<script>
    export let size = 24
    export let color = '#C5281C'
    export let style = ''
    export let title = null
</script>

<svg
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 24C5.37273 24 0 18.6273 0 12C0 5.37273 5.37273 0 12 0C18.6273 0 24 5.37273 24 12C24 18.6273 18.6273 24 12 24ZM9.29217 15.2936L10.7078 16.7064L15.4128 11.9918L10.7243 7.29362L9.30864 8.70638L12.5872 11.9918L9.29217 15.2936Z"
        fill="#6E6F71"
    ></path>
    <mask
        id="mask0_2522_158836"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 24C5.37273 24 0 18.6273 0 12C0 5.37273 5.37273 0 12 0C18.6273 0 24 5.37273 24 12C24 18.6273 18.6273 24 12 24ZM9.29217 15.2936L10.7078 16.7064L15.4128 11.9918L10.7243 7.29362L9.30864 8.70638L12.5872 11.9918L9.29217 15.2936Z"
            fill="white"
        ></path>
    </mask>
    <g mask="url(#mask0_2522_158836)">
        <rect width="24" height="24" fill={`${color}`}></rect>
    </g>
</svg>
